<template>
  
  <div id="quotation-competitors" class="sixteen wide column">
    <div class="ui segment" :class="{ loading }">
      <h4 class="ui dividing header">Concorrentes</h4>
      <form class="ui form">
        <div class="fields">
          <div class="three wide field">
            <label class="form-label">Tem Concorrência <span class="red text">*</span></label>
            <select id="select-has-competitors" class="ui fluid dropdown" v-model="hasCompetitors">
              <option value="">Selecione...</option>
              <option value="S">Sim</option>
              <option value="N">Não</option>              
            </select>
          </div>
          <div v-show="hasCompetitors == 'S'" class="eight wide field">
            <label class="form-label">Entidades <span class="red text">*</span></label>
            <select id="select-competitors" class="ui fluid search dropdown" multiple="" v-model="selectedCompetitors">
              <option value="">Selecione...</option>
              <option v-for="competitor in competitors" :value="competitor.id">
                {{ competitor.value }}
              </option>              
            </select>
          </div>          
        </div>
      </form>
    </div>
  </div>

</template>

<script>

  import QuotationService from "@/services/quotation-service"

  const NO_COMPETITORS_ID = "000000"

  export default {

    data() {
      return {
        loading: false,
        hasCompetitors: "",
        competitors: [],
        selectedCompetitors: [],
      }
    },
    
    props: ["quotation", "isCreating", "isUpdating"],

    watch: {

      "hasCompetitors" () {
        this.onChange()
      },

      "selectedCompetitors" () {
        this.onChange()
      },
    },

    created() {

      if (this.isUpdating) {        
        this.quotation.competitors.forEach((competitor) => this.selectedCompetitors.push(competitor.id))
        this.hasCompetitors = (this.selectedCompetitors[0] == NO_COMPETITORS_ID ? "N" : "S")
      }        
    },

    mounted() {

      $("#select-competitors").dropdown()
      $("#select-has-competitors").dropdown()

      this.loadCompetitors()
    },

    methods: {

      async loadCompetitors() {                 

        this.loading = true
        this.competitors = []

        try {          

          let competitors = []

          if (this.$store.state.quotationsCompetitors.length > 0) {
            competitors = this.$store.state.quotationsCompetitors
          } else {
            competitors = await QuotationService.getEntityList("competitor")
          }

          competitors.forEach((competitor) => {
            if (competitor.id !== NO_COMPETITORS_ID)
              this.competitors.push(competitor)
          })

          this.$store.commit("setQuotationsCompetitors", competitors)

          setTimeout(() => this.loading = false, 1000)
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }
      },

      onChange() {

        if (this.loading)
          return

        let competitors = []

        if (this.hasCompetitors == "N") {
          competitors.push({ id: NO_COMPETITORS_ID })
        } else {
          this.selectedCompetitors.forEach((id) => competitors.push({ id }))
        }          

        this.$emit("onChange", competitors)  
      },
    },
  }

</script>

